'use strict';

exports.__esModule = true;

var _templateObject = _taggedTemplateLiteralLoose(['\n    width: 100%;\n    div {\n        padding-right: 0;\n    }\n    ', ';\n'], ['\n    width: 100%;\n    div {\n        padding-right: 0;\n    }\n    ', ';\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n    width: ', ';\n    div {\n        padding-right: ', ';\n    }\n    '], ['\n    width: ', ';\n    div {\n        padding-right: ', ';\n    }\n    ']),
    _templateObject3 = _taggedTemplateLiteralLoose(['\n    width: 100%;\n    ', ';\n'], ['\n    width: 100%;\n    ', ';\n']),
    _templateObject4 = _taggedTemplateLiteralLoose(['\n        padding-right: 15px;\n        width: ', ';\n    '], ['\n        padding-right: 15px;\n        width: ', ';\n    ']),
    _templateObject5 = _taggedTemplateLiteralLoose(['\n    justify-content: space-between;\n    display: flex;\n    width: 100%;\n    flex-wrap: wrap;\n'], ['\n    justify-content: space-between;\n    display: flex;\n    width: 100%;\n    flex-wrap: wrap;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _dist = require('wendys-common-web-ui/dist');

var _wendysI18next = require('wendys-i18next');

var _styledComponentsHelper = require('../../lib/styledComponentsHelper');

var _TextField = require('../TextField');

var _TextField2 = _interopRequireDefault(_TextField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

var CountryAndCurrency = function CountryAndCurrency(_ref) {
    var country = _ref.country,
        flagUrl = _ref.flagUrl,
        currencyOptions = _ref.currencyOptions,
        selectedCurrency = _ref.selectedCurrency,
        changeSelectedCurrency = _ref.changeSelectedCurrency,
        fullWidth = _ref.fullWidth;
    return _react2.default.createElement(
        RowWrapper,
        null,
        _react2.default.createElement(
            LeftFieldWrapper,
            { fullWidth: fullWidth },
            _react2.default.createElement(_TextField2.default, {
                value: country,
                label: (0, _wendysI18next.getTranslatedString)('email_sign_up_country'),
                readOnly: true,
                inputAttributes: {
                    disabled: true,
                    'aria-describedby': 'field-description-country',
                    style: {
                        background: 'url(' + flagUrl + ') no-repeat scroll 13px 11px/24px',
                        paddingLeft: 47
                    }
                }
            }),
            _react2.default.createElement(
                'div',
                { id: 'field-description-country', className: 'field-description-full-width' },
                _react2.default.createElement(
                    'div',
                    null,
                    (0, _wendysI18next.getTranslatedString)('email_sign_up_country_description')
                )
            )
        ),
        _react2.default.createElement(
            RightFieldWrapper,
            { fullWidth: fullWidth },
            _react2.default.createElement(_dist.PickList, {
                options: currencyOptions,
                value: selectedCurrency,
                handleChange: changeSelectedCurrency,
                label: (0, _wendysI18next.getTranslatedString)('email_sign_up_currency')
            }),
            _react2.default.createElement(
                'div',
                { id: 'field-description-currency', className: 'field-description-full-width' },
                _react2.default.createElement(
                    'div',
                    null,
                    (0, _wendysI18next.getTranslatedString)('email_sign_up_currency_description')
                )
            )
        )
    );
};

var LeftFieldWrapper = _styledComponents2.default.div(_templateObject, _styledComponentsHelper.media.md(_templateObject2, function (props) {
    return props.fullWidth ? '100%' : '50%';
}, function (props) {
    return props.fullWidth ? '15px' : '30px';
}));
var RightFieldWrapper = _styledComponents2.default.div(_templateObject3, _styledComponentsHelper.media.md(_templateObject4, function (props) {
    return props.fullWidth ? '100%' : '50%';
}));

var RowWrapper = _styledComponents2.default.div(_templateObject5);
CountryAndCurrency.propTypes = {
    country: _propTypes2.default.string.isRequired,
    flagUrl: _propTypes2.default.string.isRequired,
    currencyOptions: _propTypes2.default.arrayOf(_propTypes2.default.node).isRequired,
    selectedCurrency: _propTypes2.default.string.isRequired,
    changeSelectedCurrency: _propTypes2.default.func.isRequired,
    fullWidth: _propTypes2.default.bool
};

CountryAndCurrency.defaultProps = {
    fullWidth: false
};

exports.default = CountryAndCurrency;


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/components/loginComponents/CountryAndCurrency.js
// module id = 309
// module chunks = 0